import { render, staticRenderFns } from "./SupplierProductProperties.vue?vue&type=template&id=6ba2b313&scoped=true"
import script from "./SupplierProductProperties.vue?vue&type=script&lang=js"
export * from "./SupplierProductProperties.vue?vue&type=script&lang=js"
import style0 from "./SupplierProductProperties.vue?vue&type=style&index=0&id=6ba2b313&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba2b313",
  null
  
)

export default component.exports